import { render, staticRenderFns } from "./NavAside.vue?vue&type=template&id=2fb751e4&scoped=true"
import script from "./NavAside.vue?vue&type=script&lang=js"
export * from "./NavAside.vue?vue&type=script&lang=js"
import style0 from "./NavAside.vue?vue&type=style&index=0&id=2fb751e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb751e4",
  null
  
)

export default component.exports